<template>
  <main>
    <Header />
    <div lt-lg:pt-64px>
      <RouterView />
    </div>
    <Footer />
  </main>
</template>
